import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Button, Image } from 'antd';
import '../CSS/style-guide.css'

// ExportToExcel component for exporting contract and clause data to an Excel file
const ExportToExcel = ({ data, clauses = [], fileName = 'export' }) => {

  console.log('ExportToExcel data:', data);
  console.log('ExportToExcel clauses:', clauses);
  const handleExport = async () => {
    if (!data || data.length === 0) {
      alert('No data available to export');
      return;
    }

    const workbook = new ExcelJS.Workbook();

    // Contracts Sheet
    const contractSheet = workbook.addWorksheet('Contracts');
    const contractDetails = data.map((record) => ({
      "Project Id": record.projectId,
      "Contract Id": record.contractId,
      "Contract Name": record.ContractName,
      "IsActive": record.IsActive,
      "Contract Status": record.contractStatus,
      "Effective Date": record.effectiveDate,
      "Expiration Date": record.expirationDate,
      "version": record.version,
      "Amendment Type": record.amendmentType,
      "Hierarchical Type": record.hierarchicalType,
      "Expiration Term Type": record.expirationTermType,
      "Max Number Of Renewals": record.maximumNumberOfRenewals,
      "AutoRenewal Interval": record.autoRenewalInterval,
      "isTestProject": record.isTestProject,
      "Last Modified": record.lastModified,
      "active": record.active,
      "Parent Agreement": record.parentAgreement,
      "Agreement Date": record.agreementDate,
      "Customer": Array.isArray(record.Customer) ? record.Customer.join(', ') : record.Customer,
      "Signing Legal Entity": record.signingLegalEntity,
      "Purchasing Group": record.purchasingGroup,
      "Contract Type": record.contractType,
      "Payment Terms": record.paymentTerms,
      "Billing Schedule": record.billingSchedule,
      "Supplier": record.supplier?.name || '',
      "Contract Amount": `${record.contractAmount?.amount || ''} - ${record.contractAmount?.currency || ''}`,
      "Clause Header": record.clause_header,
      "Clause Content": record.chunk,
      "Commodities": Array.isArray(record.commodities) ? record.commodities.map(c => c.name).join(', ') : '',
      "Regions": Array.isArray(record.regions) ? record.regions.map(r => r.name).join(', ') : '',
      "Document Id": record.id,
      "File Name": record.DocumentName,
      "Document Title": record.title,
      "Description": record.description,
      "Document Owner": record.DocumentOwner,
      "Document Status": record.DocumentStatus,
    }));

    const contractHeaders = Object.keys(contractDetails[0]);
    const headerRow = contractSheet.addRow(contractHeaders);

    // ✅ Bold header row
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    contractDetails.forEach(item => {
      contractSheet.addRow(Object.values(item));
    });

    // Clauses Sheet
    const clauseSheet = workbook.addWorksheet('Clauses');
    const MAX_EXCEL_CELL_LENGTH = 32000;

    const clauseDetails = clauses.map(clause => {
      const chunks = [];
      let remainingText = clause.chunk || '';

      while (remainingText.length > MAX_EXCEL_CELL_LENGTH) {
        chunks.push(remainingText.slice(0, MAX_EXCEL_CELL_LENGTH));
        remainingText = remainingText.slice(MAX_EXCEL_CELL_LENGTH);
      }
      chunks.push(remainingText);

      const baseRow = {
        "Contract Id": clause.contractId,
        "Document Id": clause.documentId.split('-')[0],
        "Document Name": clause.documentName,
        "Clause Header": clause.clause_header,
      };

      chunks.forEach((part, index) => {
        baseRow[`Chunk part ${index + 1}`] = part;
      });

      return baseRow;
    });

    if (clauseDetails.length > 0) {
      const clauseHeaders = Object.keys(clauseDetails[0]);
      const clauseHeaderRow = clauseSheet.addRow(clauseHeaders);

      // ✅ Bold clause header row
      clauseHeaderRow.eachCell((cell) => {
        cell.font = { bold: true };
      });

      clauseDetails.forEach(item => {
        clauseSheet.addRow(Object.values(item));
      });
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <>
      <Button
        type="primary"
        onClick={handleExport}
        disabled={data.length === 0}
        style={{
          height: 20,          // control button height
          paddingLeft: 5,
          paddingRight: 5,
          display: 'inline-flex',
          alignItems: 'center',
          fontSize: 12,
        }}
      >
        Export Selected to Excel
      </Button>
    </>

  );

};

export default ExportToExcel;